/* eslint-disable no-console */

'use client';
import type {
  AttributesEntity,
  VariantsEntity,
} from '@eliadmin/core/src/api/products/types/product-types';
import { ProductVariantSelect } from '@eliadmin/core/src/components/product/detail/variants/product-variant-select';
import {
  sortVariantsByAvailability,
  useVariantsStore,
} from '@eliadmin/core/src/stores/variant-store';
import Link from '@eliadmin/core/src/components/link';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

export type ProductVariantsProps = { attributes: AttributesEntity[]; variants: VariantsEntity[] };

export function ProductSizePicker() {
  const attributes = useVariantsStore(state => state.product.attributes) || [];
  const selectedVariant = useVariantsStore(s => s.selectedVariant);
  const setSelectedVariant = useVariantsStore(s => s.setSelectedVariant);
  const variants = useVariantsStore(state => state.product.variants) || [];
  const updateSelectedValue = useVariantsStore(state => state.updateSelectedValue);
  const searchParams = useSearchParams();
  const [selectedColor, setSelectedColor] = useState(
    selectedVariant?.values?.find(value => value.attribute_id === 30),
  );
  const [check, setCheck] = useState(false);

  useEffect(() => {
    if (searchParams.get('vid')) return;

    if (!selectedVariant && variants.length > 0) {
      const firstVariant = sortVariantsByAvailability(variants)[0];
      setSelectedVariant(firstVariant);

      firstVariant.values &&
        updateSelectedValue({
          attribute: { id: 30 },
          value: firstVariant.values?.find(value => value.attribute_id === 30),
        } as any);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedColor(selectedVariant?.values?.find(value => value.attribute_id === 30));
  }, [selectedVariant, check]);

  return (
    <>
      {attributes.find(attribute => attribute.name === 'Veľkosť rámu') && (
        <div className="flex w-full flex-col items-start justify-start gap-2">
          <p className="text-sm font-semibold text-foreground sm:text-base">Veľkosť rámu</p>
          <ProductVariantSelect
            selectedColor={selectedColor as any}
            attribute={
              attributes.find(attribute => attribute.name === 'Veľkosť rámu') as AttributesEntity
            }
            triggerCheck={() => setCheck(!check)}
          />
          <Link prefetch={false} href={'/vyber-velkosti'} className="w-full">
            <i className="text-sm font-normal text-primary underline">
              Ako správne vybrať veľkosť?
            </i>
          </Link>
        </div>
      )}
    </>
  );
}
